import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  green6,
  grey1,
  grey4,
  grey6,
  orange5,
} from 'approot/shared/styles/colours.style';
import {
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
} from '../../activity-builder.constants';
import {
  PRESENT_DRAWER_DETAILS_Z_INDEX,
  PRESENT_DRAWER_WIDTH,
  PRESENT_DRAWER_Z_INDEX,
} from '../activity-builder-present.constants';
import { LayoutDrawerStyled } from 'approot/shared/layout/layout.styles';

export const PresentMenuContainer = styled.aside`
  background-color: ${grey1};
  border-left: 1px solid ${grey4};
  padding: ${rem(4)};
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: ${rem(ACTIVITY_BUILDER_SETTINGS_WIDTH)};
  transform: translate3d(0, 0, 0);
  overflow: auto;
`;

type PresentDetailDrawerProps = {
  $isActive: boolean;
};
export const PresentMenuDetailDrawer = styled.div<PresentDetailDrawerProps>`
  position: fixed;
  bottom: 0;
  right: ${({ $isActive }) => ($isActive ? 0 : '-100vw')};
  top: 0;
  width: 100vw;
  z-index: ${PRESENT_DRAWER_DETAILS_Z_INDEX};

  @media (min-width: ${PRESENT_DRAWER_WIDTH}px) {
    width: ${({ $isActive }) => rem($isActive ? PRESENT_DRAWER_WIDTH : 0)};
  }

  ${LayoutDrawerStyled} {
    position: absolute;
    left: 0;
    right: 0;
    width: auto;
  }

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    z-index: ${PRESENT_DRAWER_Z_INDEX - 1};
    right: ${({ $isActive }) =>
      $isActive ? rem(ACTIVITY_BUILDER_SETTINGS_WIDTH) : '-100vw'};

    ${LayoutDrawerStyled} {
      border-left: 1px solid ${grey4};
      box-shadow: none;
      transition: none;
      transform: none;
    }
  }
`;

type PresentMenuStudentStatusProps = {
  $isOnline?: boolean;
  $isNeutral?: boolean;
};
export const PresentMenuStudentStatus = styled.div<PresentMenuStudentStatusProps>`
  width: ${rem(8)};
  height: ${rem(8)};
  border-radius: 50%;
  background-color: ${({ $isOnline, $isNeutral }) =>
    $isOnline ? green6 : $isNeutral ? orange5 : grey6};
`;
